<template>
  <div id="app">
    <div class="app-container">
      <router-view/>

      <!--返回小程序首页按钮-->

      <!-- <div style="position: fixed;bottom: 64px;right: 16px;" @click="goHome">
        <img src="~@/assets/images/mini.png" style="width: 36px;display: inline-block;box-shadow: 2px 2px 2px grey;border-radius: 100%;"/>
      </div> -->
    </div>
  </div>
</template>

<style>
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  min-height: 100vh;
  background-color: #f5f5f5;
}

.app-container {
  max-width: 760px; /* 平板宽度 */
  margin: 0 auto;
  min-height: 100vh;
  background-color: #f5f5f5;
  box-shadow: 0 0 20px rgba(0, 0, 0, 0.1);
  position: relative;
}

/* 限制固定定位元素在容器内 */
.app-container .payment {
  position: fixed !important;
  top: 0 !important;
  left: 50% !important;
  right: auto !important;
  transform: translateX(-50%) !important;
  width: 100% !important;
  max-width: 760px !important;
  z-index: 999 !important;
}

/* 限制底部tabbar在容器内 */
.app-container .van-tabbar {
  position: fixed !important;
  bottom: 0 !important;
  left: 50% !important;
  right: auto !important;
  transform: translateX(-50%) !important;
  width: 100% !important;
  max-width: 760px !important;
  z-index: 999 !important;
}

/* 当屏幕宽度小于等于760px时，占满全屏 */
@media (max-width: 460px) {
  .app-container {
    max-width: 100%;
    box-shadow: none;
  }
  
  #app {
    /* background-color: #ffffff; */
  }
  
  .app-container .payment {
    left: 0 !important;
    right: 0 !important;
    transform: none !important;
    max-width: 100% !important;
  }
  
  .app-container .van-tabbar {
    left: 0 !important;
    right: 0 !important;
    transform: none !important;
    max-width: 100% !important;
  }
}

#nav {
  padding: 30px;
}

#nav a {
  font-weight: bold;
  color: #2c3e50;
}

#nav a.router-link-exact-active {
  color: #42b983;
}
</style>

<script>
  import stroe from './store'


  export default {
    data() {
      return {
        active: 0,
        action_text: 2,
        search_keyword: '',
        classify_id: ''
      }
    },
    watch: {
        getStoreItem () {
            this.active = stroe.state.tarbarIndex;
        },
        search_keyword () {
          this.$store.commit('setSearchKeyword',this.search_keyword)
        },
        searchShow()
        {
          if( this.searchShow )
          {
            if ( this.$route.query.classify_id )
            {
              this.classify_id = this.$route.query.classify_id
            } else
            {
              this.classify_id = ''
            }
          }
        }
    },
    methods:{

      goHome()
      {

        //所以apappf不能用switchTab
        if( location.href.indexOf('apappf') !== -1 )
        {
          wx.miniProgram.redirectTo({
            url: '/pages/index/main'
          })
        }else{
          wx.miniProgram.switchTab({
            url: '/pages/index/main'
          })
        }
      },
      onSearch()
      {

      },
      keywordSearch()
      {
        this.$store.commit('setSearchShow','')
        let is_intern = this.$route.query.is_intern?1:''
        this.$router.push({ path: '/payment', query: { classify_id: this.classify_id, keyword: this.searchKeyword, is_intern: is_intern }})
      },
      goSearchHot(id)
      {
        // alert('热门搜索');
        this.$store.commit('setSearchShow','')
        this.$router.push({ path: '/payment', query: { classify_id: id }})
      },
      cancelSearch()
      {
        this.$store.commit('setSearchShow','')
      },
      searchFocusIn()
      {
        this.$store.commit('setSearchFocus',1)
      },
      searchBlur()
      {
        this.$store.commit('setSearchFocus','')
      },
        committarbar(ind)
      {
          alert(ind)
          this.active = ind;
      },
      swtichTabbar(ind)
      {
        let path = '';
        if( ind == 0 )
        {
          path = '/payment'
        } else if ( ind == 1 )
        {
          path = '/payment'

          // this.$store.commit('setSearchShow',1)

        }else if ( ind == 2 )
        {
          path = '/invoice'
        } else if ( ind == 3 )
        {
          path = '/invoice'
        }else if ( ind == 4 )
        {
          path = '/mine'
        }
        this.$router.push(path)
      }
    },
    mounted()
    {
     

    },
    computed :{
        getStoreItem () {
            return stroe.state.tarbarIndex
        },
        tarbarShow() {
            return stroe.state.tarbarShow
        },
        searchShow()
        {
            return stroe.state.searchShow
        },
        searchFocus()
        {
          return stroe.state.searchFocus
        },
        searchKeyword()
        {
          return stroe.state.searchKeyword
        },

    }
  }
</script>
